module.exports = __webpack_public_path__ + "c29c7713a2ddfd50af0c2e1cef452303.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/martin-kleppe.jpg
// module id = 447
// module chunks = 0